window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var cfg = ns.config;

  var state = $.extend(true, {}, cfg.DEFAULT_STATE);
  window.emState = state;

  var allDates = {};
  var lastDateFetched = null;
  var isLoading = false;
  var isAutoScroll = 0;
  var bookingProcessing = false;
  var lastUpdateCalendarPromise = null;
  var finishedLoading = false;

  ns.state = {
    get: function () {
      return state;
    },
    set: function (newState) {
      state = newState;
      window.emState = state;
    },
    reset: function () {
      state = $.extend(true, {}, cfg.DEFAULT_STATE);
      window.emState = state;
      return state;
    },
    patch: function (updates) {
      var keys = Object.keys(updates);
      for (var i = 0; i < keys.length; i++) {
        state[keys[i]] = updates[keys[i]];
      }
    },

    getAllDates: function () {
      return allDates;
    },
    mergeDates: function (newDates) {
      for (var x in newDates) {
        allDates[x] = newDates[x];
      }
    },

    getLastDateFetched: function () {
      return lastDateFetched;
    },
    setLastDateFetched: function (val) {
      lastDateFetched = val;
    },

    isLoading: function () {
      return isLoading;
    },
    setLoading: function (val) {
      isLoading = val;
    },

    getAutoScroll: function () {
      return isAutoScroll;
    },
    setAutoScroll: function (val) {
      isAutoScroll = val;
    },
    incrementAutoScroll: function () {
      isAutoScroll++;
    },
    decrementAutoScroll: function () {
      isAutoScroll--;
    },

    isBookingProcessing: function () {
      return bookingProcessing;
    },
    setBookingProcessing: function (val) {
      bookingProcessing = val;
    },

    getLastCalendarPromise: function () {
      return lastUpdateCalendarPromise;
    },
    setLastCalendarPromise: function (val) {
      lastUpdateCalendarPromise = val;
    },

    isFinishedLoading: function () {
      return finishedLoading;
    },
    setFinishedLoading: function (val) {
      finishedLoading = val;
    },
  };
})(window.EM.booking);
